
<Transition :name="transition">
  <div
    v-show="isActive"
    tabindex="0"
    class="rr-rating-vld-overlay is-active"
    :class="{ 'is-full-page': isFullPage }"
    :aria-busy="isActive"
    aria-label="Loading"
    :style="{ zIndex: zIndexValue }"
  >
    <div
      class="rr-rating-vld-background"
      :style="{ background: backgroundColor, opacity: opacity }"
      @click.prevent="cancel"
    ></div>
    <div class="rr-rating-vld-icon">
      <slot name="before"></slot>
      <slot name="default">
        <component
          :is="loaderdata"
          :color="color"
          :width="widthBar"
          :height="heightBar"
        ></component>
      </slot>
      <slot name="after"></slot>
    </div>
  </div>
</Transition>
